<template>
  <div class="Appointment">
    <div class="chart" ref="chart"/>
  </div>
</template>

<script>
import echarts from "echarts";
import api from '../api'

export default {
  name: "Appointment",
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.queryInfo()
  },
  methods: {
    async queryInfo() {
      const {success, returnObj} = await this.$fetch(api.platform.queryAppointmentVehicleTotal)
      if (success) {
        this.initCharts(returnObj)
      }
    },
    initCharts(obj) {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      const xData = ["未开始", "进行中", "已完成"];
      const yData = [20, 50, 30];
      const option = {
        grid: {
          bottom: 10,
          containLabel: true,
          left: 25,
          right: 10,
        },
        tooltip: {
          show: true,
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "rgba(255,255,255,0.7)",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#1B7EF2",
              }
            }
          }
        ],
        yAxis: [
          {
            minInterval: 1,
            show: true,
            type: "value",
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#2D3C5C",
              },
            },
          },
        ],
        series: [
          {
            type: "custom",
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: "group",
                children: [
                  {
                    type: "CubeLeft",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: "#1B7EF2",
                        },
                        {
                          offset: 1,
                          color: "rgba(27,126,242,0)",
                        },
                      ]),
                    },
                  },
                  {
                    type: "CubeRight",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: "#1B7EF2", // 顶部
                        },
                        {
                          offset: 1,
                          color: "rgba(27,126,242,0)", // 底部
                        },
                      ]),
                    },
                  },
                  {
                    type: "CubeTop",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: '#74B4FF',
                    },
                  },
                ],
              };
            },
            data: [obj.noStartTotal, obj.inProgressTotal, obj.finishTotal],
          },
        ],
      };
      const CubeLeft = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c0 = [shape.x, shape.y];
          const c1 = [shape.x - 20, shape.y - 4];
          const c2 = [xAxisPoint[0] - 20, xAxisPoint[1] - 4];
          const c3 = [xAxisPoint[0], xAxisPoint[1]];
          ctx
              .moveTo(c0[0], c0[1])
              .lineTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .closePath();
        },
      });
      const CubeRight = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c1 = [shape.x, shape.y];
          const c2 = [xAxisPoint[0], xAxisPoint[1]];
          const c3 = [xAxisPoint[0] + 8, xAxisPoint[1] - 4];
          const c4 = [shape.x + 8, shape.y - 4];
          ctx
              .moveTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .lineTo(c4[0], c4[1])
              .closePath();
        },
      });
      const CubeTop = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
        },
        buildPath: function (ctx, shape) {
          // 逆时针 角 y 负数向上  X 负数向左
          const c1 = [shape.x, shape.y];
          const c2 = [shape.x + 8, shape.y - 4];
          const c3 = [shape.x - 11, shape.y - 8];
          const c4 = [shape.x - 20, shape.y - 4];
          ctx
              .moveTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .lineTo(c4[0], c4[1])
              .closePath();
        },
      });
      echarts.graphic.registerShape("CubeLeft", CubeLeft);
      echarts.graphic.registerShape("CubeRight", CubeRight);
      echarts.graphic.registerShape("CubeTop", CubeTop);
      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(option);
    }
  }
}
</script>

<style lang="scss" scoped>
.Appointment {
  height: 100%;
  width: 100%;

  .chart {
    height: 100%;
    width: 100%;
  }
}
</style>
